module.exports = __webpack_public_path__ + "assets/img/station23.b4913a29.png";